export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4699.02fa6cb0.jpg";